module.exports = __webpack_public_path__ + "src/images/metube.2e21c9a3665768dbec0548e189b3f693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/metube.jpg
// module id = 120
// module chunks = 0